<div class="header-helper">
  Your system activity on your account is listed below.
</div>

<div class="content content-with-elevation">
  <div class="full-table">
    <lib-audit-log-individual-section *ngFor="let log of auditLog" [auditLog]="log"></lib-audit-log-individual-section>
  </div>
</div>
